var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.close)?_c('al-card',{attrs:{"noPadding":""}},[_c('p',{class:_vm.type},[_vm._v(_vm._s(_vm.content))]),_vm._v(" "),(_vm.showClose)?_c('div',{staticClass:"close-icon iconfont icon-auro-close",class:_vm.type,on:{"click":function($event){_vm.close=true}}}):_vm._e()]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-60f3622b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/Message/index.vue
// module id = 723
// module chunks = 0